// extracted by mini-css-extract-plugin
module.exports = {"section":"about-module--section--joRXC","aboutText":"about-module--aboutText--1u59C","img":"about-module--img--2LKxs"};